
import _Vue, { VueConstructor } from 'vue'
import { validationMixin } from 'vuelidate'

type Erro = Record<string, unknown> | undefined

type ParametrosNumeric = {
  numeric: boolean;
}

type ParametrosMinLength = {
  minLength: {
    min: number;
  };
}

type Parametros = ParametrosNumeric | ParametrosMinLength

interface Computed {
  valido: boolean;
  erro: Erro | null;
  mensagemDeErro: string | null;
}

interface Methods {
  registradorDeValidador: (idDoValidador: number) => void;
  atualizadorDeValorDoValidador: (idDoValidador: number, valorDaValidacao: boolean) => void;
  desregistradorDeValidador: (idDoValidador: number) => void;
  executarValidador: () => void;
}

const Vue = _Vue as VueConstructor<_Vue & Methods & Computed>

export default Vue.extend({
  name: 'PValidadorDeFormulario',

  mixins: [validationMixin],

  inject: ['registradorDeValidador', 'atualizadorDeValorDoValidador', 'desregistradorDeValidador'],

  computed: {
    valido (): boolean {
      return !this.$v.$anyError
    },

    erro (): Erro | null {
      if (this.valido) {
        return null
      } else {
        const validacoes = this.$v
        const possuiValidacoes = !!validacoes
        if (!possuiValidacoes) return null
        const camposDeValidacao = Object.keys(this.$v.$params)

        const chaveDoCampoProblematico = camposDeValidacao.find((key: string): boolean => {
          return validacoes[key].$error === true
        }) as string
        return validacoes[chaveDoCampoProblematico]
      }
    },

    mensagemDeErro (): string | null {
      const erro = this.erro as unknown as Erro
      if (!erro) return null
      const parametros = erro.$params as Parametros

      const pegarDescricaoGenericaDoConjuntoPorTipo = (): string => {
        const valor = this.$v.value.$model
        if (Array.isArray(valor)) {
          return 'itens'
        } else if (typeof valor === 'string') {
          return 'caracteres'
        } else if (typeof valor === 'number') {
          return 'digitos'
        }
        return 'chaves'
      }

      if (erro.required === false) {
        return '*'
      } else if (erro.numeric === false) {
        return 'Este campo só pode ser preenchido com números'
      } else if (erro.minLength === false) {
        const quantidade = (parametros as ParametrosMinLength).minLength.min
        const descricaoDoConjunto = pegarDescricaoGenericaDoConjuntoPorTipo()
        return `Este campo precisa ser preenchido com pelo menos ${quantidade} ${descricaoDoConjunto}`
      }
      return 'Este campo não está válido'
    }
  },

  methods: {
    executarValidador (): void {
      if (this.$v.value) {
        this.$v.value.$touch()
      }
    }
  },

  mounted () {
    const idDesteComponente = this._uid
    this.registradorDeValidador(idDesteComponente)
    this.atualizadorDeValorDoValidador(idDesteComponente, this.valido)
  },

  beforeDestroy () {
    const idDesteComponente = this._uid
    this.desregistradorDeValidador(idDesteComponente)
  },

  watch: {
    valido (novoValor: boolean): void {
      const idDesteComponente = this._uid
      this.atualizadorDeValorDoValidador(idDesteComponente, novoValor)
    },
    value: {
      immediate: true,
      handler (novoValor: unknown, valorAntigo: unknown): void {
        if (novoValor === valorAntigo) return
        this.executarValidador()
      }
    }
  }
})
